/* eslint-disable react/sort-comp */
import React from 'react';
import { Modal } from '@ctsu/react-ctsu-ui';
import { Button } from 'components/CustomComponents';
import { ATCONSTANTS as ATC } from 'appconstants';

let confirmFn;

class Confirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: '',
      firstBtnName: '',
      secondBtnName: '',
      renderComp: undefined,
      header: undefined,
      disableBtn: false,
      modalFooter: undefined,
      isClose: true,
      autoCloseOnAction: true,
      fullscreen: ''
    };
  }

  componentDidMount() {
    confirmFn = this.openConfirmation;
  }

  openConfirmation = ({
    message,
    renderComp,
    header,
    headerCb,
    onAction,
    firstBtn,
    secondBtn,
    closeHandler,
    disableBtn,
    modalFooter,
    isClose,
    autoCloseOnAction,
    fullscreen,
    modalSize,
    onClose
  }) => {
    this.setState({
      open: true,
      firstBtnHandler: onAction,
      message,
      firstBtnName: firstBtn,
      secondBtnName: secondBtn,
      renderComp,
      header,
      disableBtn,
      modalFooter,
      isClose,
      autoCloseOnAction,
      fullscreen,
      modalSize,
      onClose
    });
    this.headerHandler = headerCb;
    this.closeHandler = closeHandler;
    this.handleClose = this.handleClose.bind(this);
    return this;
  };

  close = () => this.setState({ open: false });

  handleEdit = () => {
    const { firstBtnHandler, autoCloseOnAction } = this.state;
    firstBtnHandler(this.close);
    if (autoCloseOnAction) {
      this.close();
    }
  };

  setHeaderCb = (label) => {
    const headerVal = this.headerHandler(label);
    if (headerVal === undefined) {
      this.setState({ header: label });
      return;
    }
    this.setState({ header: headerVal });
  };

  handleClose(event, reason) {
    this.close();
    if (this.closeHandler) {
      this.closeHandler();
    }
  }

  render() {
    const {
      open,
      message,
      firstBtnName,
      renderComp,
      header,
      secondBtnName,
      disableBtn,
      modalFooter,
      isClose,
      fullscreen,
      modalSize,
      onClose
    } = this.state;
    const showMessage = message || (renderComp != null ? renderComp(this.setHeaderCb) : null);
    return open ? (
      <Modal
        modalTitle={header}
        modalSize={modalSize}
        onClose={() => (onClose ? onClose() : this.handleClose())}
        buttonText={secondBtnName}
        modalFooter={modalFooter}
        showCloseBtn={isClose}
        className={fullscreen}
      >
        <div className="card-body dialogBody p-0">
          <div className="row">
            <div data-id={`${ATC.APP}MESSAGE_TEXT{ATC.DIV}`} className="col-12 message" data-testid="message">
              {showMessage}
            </div>
          </div>
          <div className="display-inline float-right actionBtns">
            {firstBtnName !== undefined ? (
              <Button
                className="btn py-1 px-3 turquoise firstBtn"
                data-id={`${ATC.APP}FIRST{ATC.BUTTON}`}
                data-testid="first-button"
                isDisabled={disableBtn}
                buttonHandler={this.handleEdit}
                name={firstBtnName}
              />
            ) : null}
          </div>
        </div>
      </Modal>
    ) : null;
  }
}

export function openConfirmation({
  message = undefined,
  renderComp = undefined,
  header,
  headerCb = () => undefined,
  onAction = undefined,
  firstBtn = undefined,
  secondBtn = undefined,
  disableBtn = false,
  closeHandler = () => undefined,
  modalFooter = undefined,
  isClose = undefined,
  autoCloseOnAction = true,
  fullscreen,
  modalSize,
  onClose = undefined
}) {
  return confirmFn({
    renderComp,
    header,
    message,
    onAction,
    firstBtn,
    secondBtn,
    disableBtn,
    closeHandler,
    headerCb,
    modalFooter,
    isClose,
    autoCloseOnAction,
    fullscreen,
    modalSize,
    onClose
  });
}

export default Confirmation;
